interface MediaItem {
  title: string;
  meta: string;
  desc: string;
  imageUrl: string;
  imageAlt: string;
}

const mediaItems: MediaItem[] = [
  {
    title: '《星际穿越》重映特辑',
    meta: '科幻经典 · 4K修复版',
    desc: '诺兰科幻神作重返大银幕，IMAX 4K 修复版带来前所未有的视觉震撼',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20space%20scene%20with%20a%20massive%20black%20hole%20and%20starship%2C%20dramatic%20cinematic%20lighting%20with%20warm%20golden%20accretion%20disk%2C%20deep%20space%20backdrop%2C%20film%20grain%20texture%2C%20movie%20still%20photography%2C%20professional%20sci-fi%20cinematography&width=800&height=450&seq=media-1-wuma&orientation=landscape',
    imageAlt: '星际穿越重映特辑预告片封面',
  },
  {
    title: '《哪吒之魔童闹海》幕后',
    meta: '国产动画 · 制作特辑',
    desc: '五年磨一剑，探秘国产动画里程碑作品的创作幕后与匠心工艺',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20concept%20art%20with%20mythological%20dragon%20in%20stormy%20skies%2C%20vibrant%20red%20and%20gold%20color%20scheme%2C%20traditional%20Chinese%20painting%20influence%2C%20epic%20fantasy%20atmosphere%2C%20dynamic%20composition%2C%20professional%20animation%20art&width=800&height=450&seq=media-2-wuma&orientation=landscape',
    imageAlt: '哪吒之魔童闹海幕后制作特辑',
  },
  {
    title: '《奥本海默》深度解读',
    meta: '历史传记 · 影评解析',
    desc: '诺兰最新力作深度解析，从叙事结构到视觉符号的全面影评',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20black%20and%20white%20cinematic%20portrait%20with%20intense%20expression%2C%20explosion%20mushroom%20cloud%20in%20distant%20background%2C%20film%20noir%20lighting%2C%20strong%20contrast%2C%20historical%20drama%20aesthetic%2C%20professional%20movie%20cinematography&width=800&height=450&seq=media-3-wuma&orientation=landscape',
    imageAlt: '奥本海默深度解读影评',
  },
  {
    title: '《沙丘2》视觉盛宴',
    meta: '科幻史诗 · 视效解析',
    desc: '维伦纽瓦打造的沙漠史诗，每一帧都是壁纸级别的视觉奇观',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vast%20desert%20landscape%20with%20massive%20sandworms%20and%20ancient%20architecture%2C%20golden%20hour%20lighting%2C%20warm%20sand%20tones%2C%20epic%20scale%2C%20cinematic%20composition%2C%20professional%20movie%20still%20with%20atmospheric%20haze&width=800&height=450&seq=media-4-wuma&orientation=landscape',
    imageAlt: '沙丘2视觉盛宴预告',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              精彩预告
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              最新电影预告片与深度幕后特辑，抢先感受大银幕的无限魅力
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {mediaItems.map((item, idx) => (
              <div
                key={idx}
                className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-52 md:h-60 overflow-hidden bg-background-200">
                  <img
                    src={item.imageUrl}
                    alt={item.imageAlt}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-black/50 backdrop-blur-sm group-hover:bg-primary-500 transition-colors duration-300">
                      <i className="ri-play-fill text-white text-2xl md:text-3xl ml-1"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-3 right-3 px-2 py-1 rounded bg-black/60 text-white text-xs">
                    04:32
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mb-2">{item.meta}</p>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}